module.exports = __webpack_public_path__ + "static/media/email.dc7cc8e9.svg";